import { __decorate, __metadata } from "tslib";
import { Type } from '@ftr/serialization';
import { LocalDateTimeRange } from '../../type/shared';
export class PriceCalculationParams {
    /**
     * @param timeRanges The time ranges to derive the request duration from when calculating a per-minute rate.
     */
    constructor(timeRanges) {
        this.timeRanges = timeRanges;
    }
}
__decorate([
    Type(() => LocalDateTimeRange),
    __metadata("design:type", Array)
], PriceCalculationParams.prototype, "timeRanges", void 0);
